import { render, staticRenderFns } from "./CatalogingUpdater.vue?vue&type=template&id=3ecc5696&"
import script from "./CatalogingUpdater.vue?vue&type=script&lang=js&"
export * from "./CatalogingUpdater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports